import type { paths } from '@orlikfy/api-interfaces';

export type { UserGameDto } from '@orlikfy/api-interfaces';

// GET /user/{userId}/games
export const GET_USER_GAMES_PATH = '/user/{userId}/games' as const satisfies keyof paths;
type GetUserGamesOperation = paths[typeof GET_USER_GAMES_PATH]['get'];
export type GetUserGamesPathParams = GetUserGamesOperation['parameters']['path'];
export type GetUserGamesResponse = GetUserGamesOperation['responses'][200]['content']['application/json'];
